import renderInputField from 'components/FormControls/textInput'
import GridSpinner from 'components/UI/GridSpinner'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Field } from 'redux-form'
import { useGetAccountLogin } from 'modules/Forms/Account/Create/subcomponents/LoginField/useGetAccountLogin'

const OneLoginField = ({ autofill, networkId, label }) => {
  const { t } = useTranslation()
  const { loadingLogin, getAccountLogin } = useGetAccountLogin(networkId)
  const [userLoginPrefix, setUserLoginPrefix] = useState('')
  const [isNotEditable, setIsNotEditable] = useState(false)

  useEffect(() => {
    if (networkId) {
      autofill('network', networkId)

      getAccountLogin(networkId).then(({ postfix, prefix, disabled }) => {
        setIsNotEditable(disabled)
        setUserLoginPrefix(prefix)
        autofill('login', prefix + postfix)
      })
    }
  }, [networkId])

  return (
    <Field
      prefix={userLoginPrefix}
      type="text"
      disabled={loadingLogin || isNotEditable}
      fullWidth
      name="login"
      required
      component={renderInputField}
      label={t(label)}
      normalize={(val) => (val ? userLoginPrefix + val : '')}
      format={(val) => val.replace(userLoginPrefix, '')}
      t={t}
      InputProps={{
        startAdornment: loadingLogin && <GridSpinner width={24} />,
      }}
    />
  )
}

OneLoginField.propTypes = {
  autofill: PropTypes.func,
  networkId: PropTypes.string,
  label: PropTypes.string,
  multiLogin: PropTypes.bool,
  networkType: PropTypes.string,
  required: PropTypes.bool,
}

export default OneLoginField
